import Calendar from "react-calendar";
import { styled } from "styled-components";
import { convertFontSize } from "./Util";

const StyledCalendar = styled(Calendar)`
  position: absolute;
  top: 45px;
  left: 0;
  // width: 30vw;
  width: 350px;
  background: white;
  border: 2px solid #27C4D5;
  margin-top: 5px;
  padding: 5px;
  border-radius: 20px;
  font-family: TbellFont;
  // line-height: 1.125em;
  z-index: 10;

  @media (max-width: 768px) {
    width: 250px;
  }

  &,
  * {
  color: #333333;
  }

  &,
  *,
  *:before,
  *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  button {
    margin: 0;
    border: 0;
    outline: none;
  }
  button:enabled:hover {
    cursor: pointer;
  }

.react-calendar__navigation {
  display: flex;
  justify-content: center;
  height: 44px;
  // margin-bottom: 1em;
  margin-bottom: 15px;
}
.react-calendar__navigation button {
  min-width: 44px;
  background: none;
}
.react-calendar__navigation button:enabled:hover,
.react-calendar__navigation button:enabled:focus {
  background-color: #e6e6e6;
}
.react-calendar__navigation button[disabled],
.react-calendar__navigation button:disabled {
  background-color: transparent
}
.react-calendar__month-view__weekdays {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  // font-size: 0.75em;
  font-size: ${convertFontSize(12, 16)};
}
.react-calendar__month-view__weekdays__weekday {
  padding: 0.5em;
}
// .react-calendar__month-view__weekNumbers {
//   font-weight: bold;
// }
.react-calendar__month-view__weekNumbers .react-calendar__tile {
  display: flex;
  align-items: center;
  justify-content: center;
  // font-size: 0.75em;
  font-weight: bold;
  font-size: ${convertFontSize(12, 16)};
  // padding: calc(0.75em / 0.75) calc(0.5em / 0.75);
  // padding: 1.5%;
}
.react-calendar__month-view__days__day {
  * {
    font-size: ${convertFontSize(12, 16)};
  }
}
.react-calendar__month-view__days__day--weekend {
  color: #d10000;
}
.react-calendar__month-view__days__day--neighboringMonth {
  color: #757575;
}
.react-calendar__year-view .react-calendar__tile,
.react-calendar__decade-view .react-calendar__tile,
.react-calendar__century-view .react-calendar__tile {
  // padding: 2em 0.5em;
  padding: 1.5%;
}
.react-calendar__tile {
  max-width: 100%;
  text-align: center;
  // padding: 0.75em 0.5em;
  padding: 0.5em;
  background: none;
}
.react-calendar__tile:disabled {
  opacity: 0.4;
  pointer-events: none;
  background-color: transparent;
}
.react-calendar__tile:enabled:hover,
.react-calendar__tile:enabled:focus {
  background-color: #e6e6e6;
  border-radius: 0;
}
.react-calendar__tile--now {
  background: #ffff76;
}
.react-calendar__tile--now:disabled {
  opacity: 0.5;
  pointer-events: none;
  background: #C8C8C8;
  border-radius: 50%;
}
.react-calendar__tile--now:enabled:hover,
.react-calendar__tile--now:enabled:focus {
  background: #ffffa9;
}
.react-calendar__tile--hasActive {
  background: #27C4D5;
  border-radius: 15px;
}
.react-calendar__tile--hasActive:enabled:hover,
.react-calendar__tile--hasActive:enabled:focus {
  background: #2EA090;
  border-radius: 15px;
}
.react-calendar__tile--active {
  background: #27C4D5;
  color: #ffffff;
  &, * {
    font-weight: 600;
    color: #ffffff;
  }
}
.react-calendar__tile--active:enabled:hover,
.react-calendar__tile--active:enabled:focus {
  background: #2EA090;
  border-radius: 0;
}
.react-calendar--selectRange, .react-calendar__tile--hover {
  background-color: #e6e6e6;
}
`;

export default StyledCalendar;